import Link from "next/link";

interface JourneyCTAProps {
  title?: string;
  description?: string;
  primaryButtonText?: string;
  primaryButtonLink?: string;
}

export default function JourneyCTA({
  title = "Ready to Start Your Journey?",
  description = "Discover meaningful connections through our trusted Marathi matrimony platform.",
  primaryButtonText = "Register Free",
  primaryButtonLink = "https://marathivadhuvarsuchak.com/register",
}: JourneyCTAProps) {
  return (
    <section className="bg-gradient-to-br from-primary-50 to-secondary-50 py-16">
      <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
        <h2 className="mb-6 text-3xl font-bold text-gray-900">{title}</h2>
        <p className="mx-auto mb-8 max-w-2xl text-lg text-gray-600">
          {description}
        </p>
        <div className="flex justify-center">
          <Link
            href={primaryButtonLink}
            className="inline-block rounded-full bg-primary-600 px-8 py-4 text-lg font-medium tracking-wide text-white shadow-lg transition-all duration-300 hover:-translate-y-1 hover:bg-primary-700"
          >
            {primaryButtonText}
          </Link>
        </div>
      </div>
    </section>
  );
}
